var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"DailyWork-company"},[_c('LeftDropDownMenu',{attrs:{"MenuList":_vm.MenuList,"width":185}}),_c('div',{staticClass:"Menuline"}),_c('div',{staticClass:"router"},[_c('router-view',{ref:"routers"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }